import React, { useLayoutEffect } from 'react';
import { FaUserCircle, FaClock } from 'react-icons/fa';

import { ILectureSearchResult } from 'services';

import './LectureLargeSearchResultItem.scss';
import Hls from 'hls.js';

/**
 * ILectureLargeSearchResultItem
 *
 * @description Component properties for LectureLargeSearchResultItem
 * @property {ILectureSearchResult} result The selected lecture video from the search results
 */
interface ILectureLargeSearchResultItem {
  result: ILectureSearchResult;
}

/**
 * LectureLargeSearchResultItem
 *
 * @description Displays the selected lecture video
 */
const LectureLargeSearchResultItem: React.FC<ILectureLargeSearchResultItem> = ({ result }) => {

  const videoRef = React.createRef<HTMLVideoElement>();

  useLayoutEffect(() => {
    if (result && videoRef.current) {
      const video = videoRef.current;

      if (Hls.isSupported() && result.url.includes('.m3u8')) {
        const hls = new Hls();
        hls.loadSource(result.url);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = result.url;
        video.addEventListener('loadedmetadata', () => {
          video.play();
        });
      }
    }
  }, [result, videoRef]);

  return (
    <div className='lecture-large-video-result'>
      <h3><strong>Latest: </strong>{result.title}</h3>
      <article key={result.id} className='lecture-large-video-result__latest-result-item'>
        <div className='box'>
          <div className='switch-container switch_player wide'>
            <video
              title='Video player'
              id='universalPlayerIframe'
              ref={videoRef}
              controls
              src={result.url}
              className='universalPlayerIframe'
            >
              <track kind='captions' />
            </video>
          </div>
        </div>
        {
          result.description &&
          <div className='lecture-description' dangerouslySetInnerHTML={{ __html: result.description }} />
        }

        <div className='lecture-large-video-result__meta-data'>
          <p className='lecture-large-video-result__icon-description'>
            <FaUserCircle /> {result.author}
          </p>
          <p className='lecture-large-video-result__icon-description'>
            <FaClock /> {result.date} - {result.durationString} duration
          </p>
        </div>
      </article>
    </div>
  );
};

export default LectureLargeSearchResultItem;